import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => {
  return {
    root: {
      flexDirection: 'row',
      height: 50,
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    linkLightHover: {
      ':hover': {
        backgroundColor: theme.palette.neutralLighter,
      },
    },
    yearHeaderCell: {
      width: 190,
      minWidth: 190,
      maxWidth: 190,
      paddingLeft: 25,
      height: 50,
    },
 
    actionColumnWidth: {
      paddingLeft: 10,
      width: 370,
      minWidth: 370,
      maxWidth: 370,
    },
    regularColumnWidth: {
      width: 140,
      minWidth: 140,
      maxWidth: 140,
      paddingLeft: 10,
    },
  };
});
